import React from "react";

export default function ApproveConfirmModal({
  isOpen,
  deliverableName,
  onCancel,
  onConfirm,
  isSubmitting,
}) {
  if (!isOpen) return null;

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: "rgba(0,0,0,0.4)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 1300,
      }}
    >
      <div
        role="dialog"
        aria-modal="true"
        aria-labelledby="approve-confirm-title"
        style={{
          background: "#ffffff",
          borderRadius: "12px",
          padding: "24px",
          width: "440px",
          maxWidth: "90vw",
          display: "flex",
          flexDirection: "column",
          gap: "14px",
          boxShadow: "0 4px 20px rgba(0,0,0,0.15)",
        }}
      >
        <div>
          <h3
            id="approve-confirm-title"
            style={{
              margin: "0 0 4px 0",
              fontSize: "16px",
              fontWeight: "600",
              color: "#111827",
            }}
          >
            Approve deliverable
          </h3>
          <p style={{ margin: 0, fontSize: "13px", color: "#6b7280" }}>
            Are you sure you want to approve
            {deliverableName ? (
              <strong style={{ color: "#111827" }}> "{deliverableName}"</strong>
            ) : (
              " this deliverable"
            )}
            ? Once approved, the status cannot be undone without contacting the
            vendor.
          </p>
        </div>

        <div style={{ display: "flex", justifyContent: "flex-end", gap: "10px" }}>
          <button
            type="button"
            onClick={onCancel}
            disabled={isSubmitting}
            style={{
              background: "transparent",
              border: "none",
              color: "#6b7280",
              padding: "8px 16px",
              fontSize: "13px",
              cursor: isSubmitting ? "not-allowed" : "pointer",
            }}
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={onConfirm}
            disabled={isSubmitting}
            style={{
              background: "#4f46e5",
              color: "#fff",
              border: "none",
              padding: "8px 20px",
              borderRadius: "6px",
              fontSize: "13px",
              fontWeight: "600",
              cursor: isSubmitting ? "not-allowed" : "pointer",
              opacity: isSubmitting ? 0.6 : 1,
            }}
          >
            {isSubmitting ? "Approving..." : "Confirm Approval"}
          </button>
        </div>
      </div>
    </div>
  );
}
